__turbopack_context__.v({
  "containerClasses": "breadcrumb-module-scss-module__RbjG9G__containerClasses",
  "crumb": "breadcrumb-module-scss-module__RbjG9G__crumb",
});
